import CTLBooleanCell from "application/components/CTLBooleanCell";
import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RupeeCell from "application/components/RupeeCell";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import { reportMenus } from "globals/configuration/reports";
import { ExtensionReportMenus } from "globals/configuration/reports/ExtensionReports";
const getApollo = AuthenticationService.allowApollo();
const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  modes: getApollo
    ? ExtensionReportMenus.map((item) => ({
        id: item.key,
        name: item.name,
        iconName: item.icon,
        url: item.url,
        description: item.description,
        disabled: item.disabled,
        productionReady: item.productionReady,
      }))
    : reportMenus.map((item) => ({
        id: item.key,
        name: item.name,
        iconName: item.icon,
        url: item.url,
        description: item.description,
        disabled: item.disabled,
        productionReady: item.productionReady,
      })),
};

const operationURLS = {
  list: "/extensionBilling/list",
  pdfDownload: "/extensionBilling/generateAndDownloadPdf",
  csvDownload: "/extensionBilling/downloadCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Call Direction",
      accessor: "coralCallDirection",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Caller No",
      accessor: "callerIdNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Caller Name",
      accessor: "callerName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Destination No",
      accessor: "destinationNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Destination Name",
      accessor: "destinationName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Start Time",
      accessor: "startEpoch",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Answer Time",
      accessor: "answerEpoch",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dateTime: false,
      dataType: "date",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "End Time",
      accessor: "endEpoch",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "date",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "TalkTime (HH:MM:SS)",
      accessor: "talkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Call Answered",
      accessor: "callConnected",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      controlType: "boolean",
      dataType: "boolean",
      filterControlType: "boolean",
      filterValue: "boolean",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "call Type",
      accessor: "callType",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "MOS",
      accessor: "mos",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "cost(INR)",
      accessor: "costVal",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "pulse",
      accessor: "pulseVal",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "pulseRate",
      accessor: "pulseRate",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
